import React from 'react';
import { TitleContainer, TitleText, CountSpan } from './CustomTitle.styles';

const CustomTitle = ({ title, count }) => {
  const truncatedTitle = title?.length > 34 ? `${title.substring(0, 34)}...` : title;

  return (
    <TitleContainer>
      <TitleText>{truncatedTitle}</TitleText>
      <CountSpan>({count})</CountSpan>
    </TitleContainer>
  );
};

export default CustomTitle;
